import { InjectionToken } from '@angular/core';

export interface OrganizationAdminRoutes {
  readonly list: readonly string[];
  detail: (id: string) => readonly string[];
}

export const ORGANIZATION_ADMIN_ROUTES = new InjectionToken<OrganizationAdminRoutes>(
  'ORGANIZATION_ADMIN_ROUTES',
);
